import Konsole from "./konsole/Konsole";
const GetRemainingAmount = (price: number, discount: number, store: any, type: number, minOrderDeliveryPrice: any) => {

  // if ( type === 3 && store?.store_setting?.minimum_order_fees - (price - discount) > 0) {
  //   return store.store_setting?.minimum_order_fees - (price - discount);
  // }
  if (type == 3) {
    Konsole.log('minOrderDeliveryPriceMin', minOrderDeliveryPrice)

    // @@ min Delivery price 0 for address delivery than minimum delivery amount 0
    if (minOrderDeliveryPrice == 0) {
      return 0;
    }

    //  minDelivery prive > 0 then appli miniMum order price and store minimun price
    
    // const miniMumPrice = minOrderDeliveryPrice > 0 ? minOrderDeliveryPrice : store?.store_setting?.minimum_order_fees;

    const miniMumPrice = minOrderDeliveryPrice > 0 ? minOrderDeliveryPrice : 0;
    if (miniMumPrice - (price - discount) > 0) {
      return miniMumPrice - (price - discount)
    }

  }
  return 0;
};

export default GetRemainingAmount;
